

































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { SummaryOrderModel } from '@/models/summary-order';
import { DATA } from '@/config/data';

@Component
export default class FilterBox extends Vue {
    private eventEmit = {
        eventFilterChange: 'eventFilterChange'
    };

    @Prop({default: null})
    private summaryOrder!: SummaryOrderModel;

    selectedStatus = { value: -1, name: 'Tất cả', color: '#fff' };
    searchText = '';

    get listStatus() {
        return DATA.orderStatus.filter(x => x.value !== 10);
    }

    get listStatusOrdered() {
        return  DATA.orderStatus.sort((a, b) => {
            const x = a['orderIndex'];
            const y = b['orderIndex'];
            return ((x < y) ? -1 : ((x > y) ? 1 : 0));
        }).filter(x => x.value !== 10);
    }

    @Watch('$route.query', { immediate: true, deep: true })
    onQueryChange(newQuery: any, oldQuery: any) {
        // Xử lý logic khi query string thay đổi
        const findObj = DATA.orderStatus.find(x => x.value === Number(newQuery.status));
        this.selectedStatus = findObj ? {value: findObj.value, name: findObj.name, color: findObj.color} : { value: -1, name: 'Tất cả', color: '#fff' }
        this.$emit(this.eventEmit.eventFilterChange, {
            searchText: newQuery.search_text,
            status: this.selectedStatus
        });
        this.searchText = newQuery.search_text;
    }

    updateQueryString(params) {
        // Lấy các query string hiện tại
        const currentQuery = { ...this.$route.query };

        // Cập nhật các giá trị query string
        const newQuery = { ...currentQuery, ...params };

        // Sử dụng router để điều hướng mà không tải lại trang
        this.$router.push({ query: newQuery });
    }

    onclickStatus(status: any) {
        this.updateQueryString({status: status.value, search_text: this.searchText});
    }

    onTextSearchChange() {
        this.updateQueryString({status: this.selectedStatus.value, search_text: this.searchText});
    }

    getTotalOrder(status, format = true) {
            let total = 0;
            if(!this.summaryOrder) {
                return 0;
            }
            switch (status) {
                case 0:
                    total = this.summaryOrder.TotalStatus0;
                    break;
                case 1:
                    total = this.summaryOrder.TotalStatus1;
                    break;
                case 2:
                    total = this.summaryOrder.TotalStatus2;
                    break; 
                case 3:
                    total = this.summaryOrder.TotalStatus3;
                    break;
                case 5:
                    total = this.summaryOrder.TotalStatus5;
                    break;
                case 7:
                    total = this.summaryOrder.TotalStatus7;
                    break;
                case 9:
                    total = this.summaryOrder.TotalStatus9;
                    break;
                case 10:
                    total = this.summaryOrder.TotalStatus10;
                    break;
                case 11:
                    total = this.summaryOrder.TotalStatus11;
                    break;
                case 12:
                    total = this.summaryOrder.TotalStatus12;
                    break;
                case 13:
                    total = this.summaryOrder.TotalStatus13;
                    break;
                case 16:
                    total = this.summaryOrder.TotalStatus16;
                    break;
                default:
                    total = this.summaryOrder.TotalStatusAll;
                    break;
            }
            total = total ? total : 0;
            if(total < 999 || !format) {
                return total.toLocaleString('en-US');
            }
            return (Math.floor(total / 1000)).toLocaleString('en-US') + 'K';
        }
}
